import { render, staticRenderFns } from "./Download.vue?vue&type=template&id=fdc60e06&scoped=true&"
import script from "./Download.vue?vue&type=script&lang=js&"
export * from "./Download.vue?vue&type=script&lang=js&"
import style0 from "./Download.vue?vue&type=style&index=0&id=fdc60e06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdc60e06",
  null
  
)

export default component.exports